import { render } from "./collectionCompany.vue?vue&type=template&id=59e2b96e&scoped=true"
import script from "./collectionCompany.vue?vue&type=script&lang=js"
export * from "./collectionCompany.vue?vue&type=script&lang=js"

import "./collectionCompany.vue?vue&type=style&index=0&id=59e2b96e&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e2b96e"]])

export default __exports__